import { StyleSheet } from 'aphrodite';
import { borderColor, brandPrimary } from '../../styles/colors';
import { scrollbarBase } from '../../styles/styles';
import { THEME } from '../Theme/theme';

const { spacing, colors, common } = THEME;

export const styleSheet = StyleSheet.create({
	drawerGridArea: {
		gridArea: 'drawer',
		height: '100%',
		minHeight: '100%',
	},
	drawer: {
		display: `flex`,
		height: '100%',
	},
	drawerButton: {
		position: 'relative',
		width: 40,
		height: 40,
		borderRadius: 20,
		display: 'flex',
		justifyContent: 'center',
		alignItems: 'center',
		color: colors.primary.main,
		backgroundColor: colors.primary.light,
		transition: 'background-color 0.2s ease',
		':hover': {
			backgroundColor: colors.hover.light,
		},
		':is([data-state="on"])': {
			color: colors.primary.contrastText,
			backgroundColor: colors.primary.main,
		},
		':is([data-state="on"]):after': {
			content: '""',
			position: 'absolute',
			top: 0,
			left: -8,
			backgroundColor: colors.primary.main,
			width: 4,
			borderRadius: `0 2px 2px 0`,
			height: '100%',
		},
		':is([data-disabled])': {
			opacity: 0.5,
			pointerEvents: 'none',
		},
	},
	drawerActionButton: {
		padding: 0,
		border: 'none',
		':has(*) > svg': {
			width: 24,
			height: 24,
		},
	},
	drawerSeparator: {
		height: 2,
		backgroundColor: colors.border.main,
		marginTop: spacing.sm,
		marginBottom: spacing.sm,
		width: '100%',
	},
	drawerContent: {
		display: 'flex',
		flexDirection: 'column',
		position: 'relative',
		width: 400,
		height: '100%',
		overflowY: 'auto',
		overflowX: 'hidden',
		backgroundColor: colors.background.light,
		...scrollbarBase,
	},
	drawerContentHidden: {
		display: 'none',
	},
	drawerEdge: {
		borderLeft: common.border,
		borderRight: common.border,
		backgroundColor: colors.background.main,
		boxShadow: `0px 1px 5px 0px ${colors.border.main}`,
		display: 'flex',
		flexDirection: 'column',
		justifyContent: 'space-between',
		alignItems: 'center',
		padding: '12px 8px',
		gap: 8,
	},
	coffeeDrawerEdge: {
		borderLeft: common.border,
		borderRight: common.border,
		backgroundColor: colors.background.main,
		display: 'flex',
		flexDirection: 'column',
		justifyContent: 'space-between',
		alignItems: 'center',
		padding: '12px 8px',
		gap: 8,
	},
	fabMenu: {
		display: 'flex',
		flexDirection: 'column',
		gap: spacing.sm,
		padding: 0,
		border: `none`,
		borderRadius: 0,
		backgroundColor: 'transparent',
		boxShadow: 'none',
	},
	fabMenuItemAppDrawer: {
		position: 'relative',
		width: 40,
		height: 40,
		borderRadius: 20,
		display: 'flex',
		justifyContent: 'center',
		alignItems: 'center',
		backgroundColor: colors.primary.light,
		color: colors.primary.main,
		cursor: 'pointer',
		transition: 'transform 0.2s ease',
		':hover': {
			transform: 'scale(1.1)',
			backgroundColor: colors.hover.light,
		},
	},
	drawerToolbarContent: {
		display: 'flex',
		flexDirection: 'column',
		gap: spacing.sm,
	},
	resizeHandle: {
		boxSizing: 'border-box',
		position: 'absolute',
		left: 0,
		top: 0,
		bottom: 0,
		width: 6,
		cursor: 'col-resize',
		backgroundColor: 'transparent',
		transition: 'background-color 0.2s ease',
		borderLeft: `1px solid ${borderColor}`,
		':hover': {
			borderLeft: `2px solid ${brandPrimary}`,
		},
	},
	resizeHandleDragging: {
		borderLeft: `2px solid ${brandPrimary}`,
	},
});
